import { List } from 'immutable';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import ChatHeadingConfigPropType from 'conversations-prop-types/prop-types/ChatHeadingConfigPropType';
import { ChatWidgetLocaleContextConsumer } from '../ChatWidgetLocaleContext';
import ThreadListHeader from './ThreadListHeader';
//@ts-expect-error untyped file
import WidgetHeaderAvatarWrapper from './WidgetHeaderAvatarWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
class WidgetHeaderContent extends Component {
  render() {
    const {
      textColor
    } = this.props.coloring;
    const {
      availabilityMessage,
      chatHeadingConfig,
      chatHeadingResponders,
      createNewThread,
      customHeaderText,
      mobile,
      showAvailabilityMessage,
      showCreateThreadButton,
      showKBArticleHeader,
      showStatusIndicator,
      showThreadListHeader
    } = this.props;
    if (showKBArticleHeader) return null;
    return /*#__PURE__*/_jsx(Fragment, {
      children: showThreadListHeader ? /*#__PURE__*/_jsx(ThreadListHeader, {
        createNewThread: createNewThread,
        customHeaderText: customHeaderText,
        textColor: textColor,
        showCreateThreadButton: showCreateThreadButton
      }) : /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
        children: locale => /*#__PURE__*/_jsx(WidgetHeaderAvatarWrapper, {
          availabilityMessage: availabilityMessage,
          borderColor: textColor,
          chatHeadingConfig: chatHeadingConfig,
          chatHeadingResponders: chatHeadingResponders,
          locale: locale,
          mobile: mobile,
          showAvailabilityMessage: showAvailabilityMessage,
          showStatusIndicator: showStatusIndicator
        })
      })
    });
  }
}
WidgetHeaderContent.displayName = 'WidgetHeaderContent';
WidgetHeaderContent.propTypes = {
  availabilityMessage: PropTypes.string,
  chatHeadingConfig: ChatHeadingConfigPropType.isRequired,
  chatHeadingResponders: PropTypes.instanceOf(List).isRequired,
  coloring: PropTypes.object.isRequired,
  createNewThread: PropTypes.func.isRequired,
  customHeaderText: PropTypes.string,
  mobile: PropTypes.bool,
  showAvailabilityMessage: PropTypes.bool.isRequired,
  showCreateThreadButton: PropTypes.bool.isRequired,
  showKBArticleHeader: PropTypes.bool,
  showStatusIndicator: PropTypes.bool.isRequired,
  showThreadListHeader: PropTypes.bool.isRequired
};
export default WidgetHeaderContent;